import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { colors } from 'react-orange-ui';

import { addImageCaptcha } from '../../actions/captcha_actions';

const GridImages = styled.ul`
  display: flex;
  padding: 0;
  flex-flow: row wrap;
  width: 245px;
  height: 245px;,
`;

const StyledListItem = styled.li`
  list-style: none;
`;

const InputImage = styled.input`
  width: calc(100/3)%;
  margin: 2px;

  &:focus {
    outline: ${colors.black} dotted 2px;
  }
`;

const Images = (props) => {
  const handleClick = (e, image) => {
    e.preventDefault();
    props.addImageCaptcha(image);
  };

  const {
    images,
  } = props;

  const items = images.map((image, key) => {
    const id = `captcha-image-${key + 1}`;
    return (
      <StyledListItem>
        <InputImage
          id={id}
          type="image"
          key={key}
          value={image.value}
          src={image.data}
          alt={`Image captcha ${key + 1}`}
          onClick={e => handleClick(e, image)}
        />
      </StyledListItem>
    );
  });
  return (
    <GridImages id="captcha-images" className="rows">
      {items}
    </GridImages>
  );
};

Images.propTypes = {
  /** Action to set image for captcha */
  addImageCaptcha: PropTypes.func.isRequired,
  /** Array list of images properties */
  images: PropTypes.arrayOf(PropTypes.shape({
    format: PropTypes.string,
    value: PropTypes.number,
    data: PropTypes.string,
  })).isRequired,
};

const mapDispatchToProps = dispatch => ({
  addImageCaptcha: image => dispatch(addImageCaptcha(image)),
});

export default connect(null, mapDispatchToProps)(Images);
